export const outboundOrdersNewData = [
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "New",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "New",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "New",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "New",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "New",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "New",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "New",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "New",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "New",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "New",
  },
];
export const orderAllData = [
  {
    order: "OR-100348",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Completed",
  },
  {
    order: "OR-284920",
    shiptoname: "Rose",
    shipbydate: "03/25/2023",
    nooflines: 9,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 80,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-118337",
    shiptoname: "Jack",
    shipbydate: "03/28/2023",
    nooflines: 3,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 20,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Completed",
  },
  {
    order: "OR-699321",
    shiptoname: "Chris",
    shipbydate: "03/14/2023",
    nooflines: 1,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 35,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Completed",
  },
  {
    order: "OR-707436",
    shiptoname: "Jack",
    shipbydate: "03/10/2023",
    nooflines: 5,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 50,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Completed",
  },
  {
    order: "OR-357812",
    shiptoname: "Joey",
    shipbydate: "03/12/2023",
    nooflines: 6,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 90,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-889073",
    shiptoname: "Sonny",
    shipbydate: "03/18/2023",
    nooflines: 1,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 80,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-579032",
    shiptoname: "William",
    shipbydate: "03/05/2023",
    nooflines: 3,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 70,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-579398",
    shiptoname: "Allie",
    shipbydate: "03/02/2023",
    nooflines: 2,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 66,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Completed",
  },
  {
    order: "OR-938201",
    shiptoname: "Emma",
    shipbydate: "03/15/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 45,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
];


export const allocationOrdersPartialData = [
  {
    order: "OR-100348",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 1,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-284920",
    shiptoname: "Rose",
    shipbydate: "03/25/2023",
    nooflines: 9,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 80,
    qtybackorder: 3,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-118337",
    shiptoname: "Jack",
    shipbydate: "03/28/2023",
    nooflines: 3,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 20,
    qtybackorder: 4,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-699321",
    shiptoname: "Chris",
    shipbydate: "03/14/2023",
    nooflines: 1,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 35,
    qtybackorder: 2,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-707436",
    shiptoname: "Jack",
    shipbydate: "03/10/2023",
    nooflines: 5,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 50,
    qtybackorder: 3,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-357812",
    shiptoname: "Joey",
    shipbydate: "03/12/2023",
    nooflines: 6,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 90,
    qtybackorder: 4,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-100348",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 1,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-284920",
    shiptoname: "Rose",
    shipbydate: "03/25/2023",
    nooflines: 9,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 80,
    qtybackorder: 3,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-118337",
    shiptoname: "Jack",
    shipbydate: "03/28/2023",
    nooflines: 3,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 20,
    qtybackorder: 4,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-699321",
    shiptoname: "Chris",
    shipbydate: "03/14/2023",
    nooflines: 1,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 35,
    qtybackorder: 2,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-707436",
    shiptoname: "Jack",
    shipbydate: "03/10/2023",
    nooflines: 5,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 50,
    qtybackorder: 3,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-357812",
    shiptoname: "Joey",
    shipbydate: "03/12/2023",
    nooflines: 6,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 90,
    qtybackorder: 4,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-123456",
    shiptoname: "Sophie",
    shipbydate: "03/13/2023",
    nooflines: 2,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 45,
    qtybackorder: 2,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-234567",
    shiptoname: "Lucas",
    shipbydate: "03/19/2023",
    nooflines: 3,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 32,
    qtybackorder: 1,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-345678",
    shiptoname: "Ava",
    shipbydate: "03/17/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 64,
    qtybackorder: 5,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-456789",
    shiptoname: "Ethan",
    shipbydate: "03/21/2023",
    nooflines: 1,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 25,
    qtybackorder: 1,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-567890",
    shiptoname: "Olivia",
    shipbydate: "03/15/2023",
    nooflines: 5,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 70,
    qtybackorder: 3,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-678901",
    shiptoname: "Noah",
    shipbydate: "03/22/2023",
    nooflines: 2,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 40,
    qtybackorder: 2,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-789012",
    shiptoname: "Mia",
    shipbydate: "03/18/2023",
    nooflines: 6,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 85,
    qtybackorder: 6,
    qtyshipment: 0,
    qtyshipped: 0,
  },
  {
    order: "OR-890123",
    shiptoname: "Logan",
    shipbydate: "03/16/2023",
    nooflines: 3,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 55,
    qtybackorder: 4,
    qtyshipment: 0,
    qtyshipped: 0,
  },
];

export const allocationOrdersCompletedData = [
  {
    order: "OR-100348",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 10,
    qtyshipped: 0,
    status: "Allocation Completed",

  },
  {
    order: "OR-284920",
    shiptoname: "Rose",
    shipbydate: "03/25/2023",
    nooflines: 9,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 80,
    qtybackorder: 0,
    qtyshipment: 80,
    qtyshipped: 0,
    status: "Allocation Completed",

  },
  {
    order: "OR-118337",
    shiptoname: "Jack",
    shipbydate: "03/28/2023",
    nooflines: 3,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 20,
    qtybackorder: 0,
    qtyshipment: 20,
    qtyshipped: 0,
    status: "Allocation Completed",

  },
  {
    order: "OR-699321",
    shiptoname: "Chris",
    shipbydate: "03/14/2023",
    nooflines: 1,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 35,
    qtybackorder: 0,
    qtyshipment: 35,
    qtyshipped: 0,
    status: "Allocation Completed",

  },
  {
    order: "OR-707436",
    shiptoname: "Jack",
    shipbydate: "03/10/2023",
    nooflines: 5,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 50,
    qtybackorder: 0,
    qtyshipment: 50,
    qtyshipped: 0,
    status: "Allocation Completed",

  },
  {
    order: "OR-357812",
    shiptoname: "Joey",
    shipbydate: "03/12/2023",
    nooflines: 6,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 90,
    qtybackorder: 0,
    qtyshipment: 90,
    qtyshipped: 0,
    status: "Allocation Completed",

  },
  {
    order: "OR-889073",
    shiptoname: "Sonny",
    shipbydate: "03/18/2023",
    nooflines: 1,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 80,
    qtybackorder: 0,
    qtyshipment: 80,
    qtyshipped: 0,
    status: "Allocation Completed",

  },
  {
    order: "OR-579032",
    shiptoname: "William",
    shipbydate: "03/05/2023",
    nooflines: 3,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 70,
    qtybackorder: 0,
    qtyshipment: 70,
    qtyshipped: 0,
    status: "Allocation Completed",

  },
  {
    order: "OR-579398",
    shiptoname: "Allie",
    shipbydate: "03/03/2023",
    nooflines: 2,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 66,
    qtybackorder: 0,
    qtyshipment: 66,
    qtyshipped: 0,
    status: "Allocation Completed",

  },
  {
    order: "OR-138387",
    shiptoname: "Ross",
    shipbydate: "03/01/2023",
    nooflines: 1,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 88,
    qtybackorder: 0,
    qtyshipment: 88,
    qtyshipped: 0,
    status: "Allocation Completed",

  },
];

export const outboundOrdersInProgressData = [
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Complete",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Complete",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Complete",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Complete",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Complete",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Complete",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Complete",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Complete",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Complete",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Allocation Complete",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Backorder",
  },
];
export const outboundOrdersCompletedData = [
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
  {
    order: "OR-100345",
    shiptoname: "John",
    shipbydate: "03/11/2023",
    nooflines: 4,
    noofshipment: 0,
    noofwarehouse: 0,
    qtyorder: 10,
    qtybackorder: 0,
    qtyshipment: 0,
    qtyshipped: 0,
    status: "Shipped",
  },
];
export const OrderPickTicketDetailTable = [
  {
    shipmentLine: 1,
    location: "B1-P01",
    itemCode: "ip1154",
    description: "iPhone",
    uom: "EA",
    shipmentNumber: "SH-100010",
    qtyToPick: 10,
    pickedQty: "-",
  },
  {
    shipmentLine: 2,
    location: "A1-P01",
    itemCode: "ipd1145",
    description: "iPad",
    uom: "EA",
    shipmentNumber: "SH-100010",
    qtyToPick: 8,
    pickedQty: "-",
  },
  {
    shipmentLine: 3,
    location: "A1-P03",
    itemCode: "ipd1145",
    description: "iPad",
    uom: "EA",
    shipmentNumber: "SH-100010",
    qtyToPick: 12,
    pickedQty: "-",
  },
  {
    shipmentLine: 4,
    location: "B1-P02",
    itemCode: "ap15478",
    description: "AirPods",
    uom: "EA",
    shipmentNumber: "SH-100010",
    qtyToPick: 14,
    pickedQty: "-",
  },
];

export const shipmentdetailslist = [
  {
    line: "1",
    itemCode: "IP-192910",
    itemDesc: "IPhone XS",
    shippinguom: "EA",
    orderQty: 25,
    shipmentQty: 20,
    backorderQty: 5,
  },
  {
    line: "2",
    itemCode: "IP-55451",
    itemDesc: "IPhone 14",
    shippinguom: "EA",
    orderQty: 25,
    shipmentQty: 20,
    backorderQty: 5,
  },
  {
    line: "3",
    itemCode: "IP-192910",
    itemDesc: "IPhone XS",
    shippinguom: "EA",
    orderQty: 25,
    shipmentQty: 20,
    backorderQty: 5,
  },
  {
    line: "4",
    itemCode: "IP-55451",
    itemDesc: "IPhone 14",
    shippinguom: "EA",
    orderQty: 25,
    shipmentQty: 20,
    backorderQty: 5,
  },
  {
    line: "5",
    itemCode: "IP-192910",
    itemDesc: "IPhone XS",
    shippinguom: "EA",
    orderQty: 25,
    shipmentQty: 20,
    backorderQty: 5,
  },
  {
    line: "6",
    itemCode: "IP-55451",
    itemDesc: "IPhone 14",
    shippinguom: "EA",
    orderQty: 25,
    shipmentQty: 20,
    backorderQty: 5,
  },
  {
    line: "7",
    itemCode: "IP-192910",
    itemDesc: "IPhone XS",
    shippinguom: "EA",
    orderQty: 25,
    shipmentQty: 20,
    backorderQty: 5,
  },
  {
    line: "8",
    itemCode: "IP-55451",
    itemDesc: "IPhone 14",
    shippinguom: "EA",
    orderQty: 25,
    shipmentQty: 20,
    backorderQty: 5,
  },
];

// data for history layout
export const HistoryLaoutDataOutBoundOverviewDetail = [
  {
    day: "Today",
    items: [
      {
        time: "12:00:13 AM (CST)",
        description: "Shipped Having Qty 25 [# SH-87654321]",
        person: "Zack Wong",
        status: "Shipped",
      },
      {
        time: "12:00:13 AM (CST)",
        description: "Shipped Having Qty 25 [# SH-87654321]",
        person: "Zack Wong",
        status: "Pack Complete",
      },
      {
        time: "12:00:13 AM (CST)",
        description: "Shipped Having Qty 25 [# SH-87654321]",
        person: "Zack Wong",
        status: "Pack In Progress",
      },
      {
        time: "12:00:13 AM (CST)",
        description: "Shipped Having Qty 25 [# SH-87654321]",
        person: "Zack Wong",
        status: "Ready To Pack",
      },
      {
        time: "12:00:13 AM (CST)",
        description: "Shipped Having Qty 25 [# SH-87654321]",
        person: "Zack Wong",
        status: "Pick Complete",
      },
      {
        time: "12:00:13 AM (CST)",
        description: "Shipped Having Qty 25 [# SH-87654321]",
        person: "Zack Wong",
        status: "In Picking",
      },
      {
        time: "12:00:13 AM (CST)",
        description: "Shipped Having Qty 25 [# SH-87654321]",
        person: "Zack Wong",
        status: "Ready To Pick",
      },
    ],
  },
];

// data for wave overview
export const waveOverviewNewData = [
  {
    waveid: "001",
    description: "Test",
    priority: "Low",
    nooflinkedorders: 4,
    picktype: "Multi Shipment",
    assignedto: "Smith",
    createdat: "10/18/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "002",
    description: "Electronics",
    priority: "Highestest",
    nooflinkedorders: 10,
    picktype: "Multi Shipment",
    assignedto: "John",
    createdat: "10/19/2023",
    wavetype: "Manual",
    status: "New",
  },
  {
    waveid: "003",
    description: "Clothing",
    priority: "Highest",
    nooflinkedorders: 7,
    picktype: "Multi Shipment",
    assignedto: "Jane",
    createdat: "10/20/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "004",
    description: "Books",
    priority: "Low",
    nooflinkedorders: 3,
    picktype: "Multi Shipment",
    assignedto: "Alice",
    createdat: "10/21/2023",
    wavetype: "Manual",
    status: "New",
  },
  {
    waveid: "005",
    description: "Groceries",
    priority: "Highest",
    nooflinkedorders: 12,
    picktype: "Multi Shipment",
    assignedto: "Bob",
    createdat: "10/22/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "006",
    description: "Furniture",
    priority: "Highest",
    nooflinkedorders: 6,
    picktype: "Multi Shipment",
    assignedto: "Emma",
    createdat: "10/23/2023",
    wavetype: "Manual",
    status: "New",
  },
  {
    waveid: "007",
    description: "Toys",
    priority: "Low",
    nooflinkedorders: 5,
    picktype: "Multi Shipment",
    assignedto: "Liam",
    createdat: "10/24/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "008",
    description: "Cosmetics",
    priority: "Highest",
    nooflinkedorders: 8,
    picktype: "Multi Shipment",
    assignedto: "Sophia",
    createdat: "10/25/2023",
    wavetype: "Manual",
    status: "New",
  },
  {
    waveid: "009",
    description: "Pharmaceuticals",
    priority: "Highest",
    nooflinkedorders: 9,
    picktype: "Multi Shipment",
    assignedto: "Ethan",
    createdat: "10/26/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "010",
    description: "Stationery",
    priority: "Low",
    nooflinkedorders: 2,
    picktype: "Multi Shipment",
    assignedto: "Olivia",
    createdat: "10/27/2023",
    wavetype: "Manual",
    status: "New",
  },
];
export const waveOverviewInprogressData = [
  {
    waveid: "001",
    description: "Test",
    priority: "Low",
    nooflinkedorders: 4,
    picktype: "Multi Shipment",
    assignedto: "Smith",
    createdat: "10/18/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "002",
    description: "Electronics",
    priority: "Highestest",
    nooflinkedorders: 10,
    picktype: "Multi Shipment",
    assignedto: "John",
    createdat: "10/19/2023",
    wavetype: "Manual",
    status: "New",
  },
  {
    waveid: "003",
    description: "Clothing",
    priority: "Highest",
    nooflinkedorders: 7,
    picktype: "Multi Shipment",
    assignedto: "Jane",
    createdat: "10/20/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "004",
    description: "Books",
    priority: "Low",
    nooflinkedorders: 3,
    picktype: "Multi Shipment",
    assignedto: "Alice",
    createdat: "10/21/2023",
    wavetype: "Manual",
    status: "New",
  },
  {
    waveid: "005",
    description: "Groceries",
    priority: "Highest",
    nooflinkedorders: 12,
    picktype: "Multi Shipment",
    assignedto: "Bob",
    createdat: "10/22/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "006",
    description: "Furniture",
    priority: "Highest",
    nooflinkedorders: 6,
    picktype: "Multi Shipment",
    assignedto: "Emma",
    createdat: "10/23/2023",
    wavetype: "Manual",
    status: "New",
  },
  {
    waveid: "007",
    description: "Toys",
    priority: "Low",
    nooflinkedorders: 5,
    picktype: "Multi Shipment",
    assignedto: "Liam",
    createdat: "10/24/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "008",
    description: "Cosmetics",
    priority: "Highest",
    nooflinkedorders: 8,
    picktype: "Multi Shipment",
    assignedto: "Sophia",
    createdat: "10/25/2023",
    wavetype: "Manual",
    status: "New",
  },
  {
    waveid: "009",
    description: "Pharmaceuticals",
    priority: "Highest",
    nooflinkedorders: 9,
    picktype: "Multi Shipment",
    assignedto: "Ethan",
    createdat: "10/26/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "010",
    description: "Stationery",
    priority: "Low",
    nooflinkedorders: 2,
    picktype: "Multi Shipment",
    assignedto: "Olivia",
    createdat: "10/27/2023",
    wavetype: "Manual",
    status: "New",
  },
];
export const waveOverviewCompletedData = [
  {
    waveid: "001",
    description: "Test",
    priority: "Low",
    nooflinkedorders: 4,
    picktype: "Multi Shipment",
    assignedto: "Smith",
    createdat: "10/18/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "002",
    description: "Electronics",
    priority: "Highestest",
    nooflinkedorders: 10,
    picktype: "Multi Shipment",
    assignedto: "John",
    createdat: "10/19/2023",
    wavetype: "Manual",
    status: "New",
  },
  {
    waveid: "003",
    description: "Clothing",
    priority: "Highest",
    nooflinkedorders: 7,
    picktype: "Multi Shipment",
    assignedto: "Jane",
    createdat: "10/20/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "004",
    description: "Books",
    priority: "Low",
    nooflinkedorders: 3,
    picktype: "Multi Shipment",
    assignedto: "Alice",
    createdat: "10/21/2023",
    wavetype: "Manual",
    status: "New",
  },
  {
    waveid: "005",
    description: "Groceries",
    priority: "Highest",
    nooflinkedorders: 12,
    picktype: "Multi Shipment",
    assignedto: "Bob",
    createdat: "10/22/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "006",
    description: "Furniture",
    priority: "Highest",
    nooflinkedorders: 6,
    picktype: "Multi Shipment",
    assignedto: "Emma",
    createdat: "10/23/2023",
    wavetype: "Manual",
    status: "New",
  },
  {
    waveid: "007",
    description: "Toys",
    priority: "Low",
    nooflinkedorders: 5,
    picktype: "Multi Shipment",
    assignedto: "Liam",
    createdat: "10/24/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "008",
    description: "Cosmetics",
    priority: "Highest",
    nooflinkedorders: 8,
    picktype: "Multi Shipment",
    assignedto: "Sophia",
    createdat: "10/25/2023",
    wavetype: "Manual",
    status: "New",
  },
  {
    waveid: "009",
    description: "Pharmaceuticals",
    priority: "Highest",
    nooflinkedorders: 9,
    picktype: "Multi Shipment",
    assignedto: "Ethan",
    createdat: "10/26/2023",
    wavetype: "Auto",
    status: "New",
  },
  {
    waveid: "010",
    description: "Stationery",
    priority: "Low",
    nooflinkedorders: 2,
    picktype: "Multi Shipment",
    assignedto: "Olivia",
    createdat: "10/27/2023",
    wavetype: "Manual",
    status: "New",
  },
];

// data for wave-conditions table
export const wavesConditionslist = [
  {
    position: 1,
    column: "DTL Bin Location",
    operator: "EQUAL",
    value: 12,
    logicalOperator: "OR",
  },
  {
    position: 2,
    column: "DTL Bin",
    operator: "GREATER THAN",
    value: 6,
    logicalOperator: "AND",
  },
  {
    position: 3,
    column: "DTL Location",
    operator: "EQUAL",
    value: 12,
    logicalOperator: "-",
  },
  {
    position: 4,
    column: "DTL Section",
    operator: "LESS THAN",
    value: 8,
    logicalOperator: "OR",
  },
  {
    position: 5,
    column: "DTL Rack",
    operator: "NOT EQUAL",
    value: 10,
    logicalOperator: "AND",
  },
];

// data for waves orders table
export const wavesOrdersList = [
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    numOfLines: 4,
    numOfShipment: 0,
    numOfWarehouse: 0,
    orderQty: 10,
    backorderQty: 0,
    shipmentQty: 0,
  },
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    numOfLines: 4,
    numOfShipment: 0,
    numOfWarehouse: 0,
    orderQty: 10,
    backorderQty: 0,
    shipmentQty: 0,
  },
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    numOfLines: 4,
    numOfShipment: 0,
    numOfWarehouse: 0,
    orderQty: 10,
    backorderQty: 0,
    shipmentQty: 0,
  },
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    numOfLines: 4,
    numOfShipment: 0,
    numOfWarehouse: 0,
    orderQty: 10,
    backorderQty: 0,
    shipmentQty: 0,
  },
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    numOfLines: 4,
    numOfShipment: 0,
    numOfWarehouse: 0,
    orderQty: 10,
    backorderQty: 0,
    shipmentQty: 0,
  },
];

// data for wave templates
export const waveTemplatesOverviewData = [
  {
    waveid: "012",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "011",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "010",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "009",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "008",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "007",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "006",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "005",
    description: "New Wave",
    priority: "Medium",
    maxorderlimit: 3,
    picktype: "Single shipment",
    shippingtype: "2/Pkg Per Order",
    createdat: "10/17/2023",
    status: "Inactive",
  },
  {
    waveid: "004",
    description: "New Wave",
    priority: "High",
    maxorderlimit: 4,
    picktype: "Multi shipment",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/16/2023",
    status: "Active",
  },
  {
    waveid: "003",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Single shipment",
    shippingtype: "3/Pkg Per Order",
    createdat: "10/15/2023",
    status: "Inactive",
  },
  {
    waveid: "002",
    description: "New Wave",
    priority: "High",
    maxorderlimit: 5,
    picktype: "Multi shipment with sort",
    shippingtype: "2/Pkg Per Order",
    createdat: "10/14/2023",
    status: "Active",
  },
  {
    waveid: "001",
    description: "New Wave",
    priority: "Medium",
    maxorderlimit: 3,
    picktype: "Single shipment",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/13/2023",
    status: "Inactive",
  },
  {
    waveid: "000",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/12/2023",
    status: "Active",
  },
  {
    waveid: "015",
    description: "New Wave",
    priority: "High",
    maxorderlimit: 6,
    picktype: "Multi shipment",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/11/2023",
    status: "Inactive",
  },
  {
    waveid: "016",
    description: "New Wave",
    priority: "Medium",
    maxorderlimit: 3,
    picktype: "Single shipment",
    shippingtype: "2/Pkg Per Order",
    createdat: "10/10/2023",
    status: "Active",
  },
  {
    waveid: "017",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/09/2023",
    status: "Inactive",
  },
  {
    waveid: "018",
    description: "New Wave",
    priority: "High",
    maxorderlimit: 5,
    picktype: "Multi shipment",
    shippingtype: "3/Pkg Per Order",
    createdat: "10/08/2023",
    status: "Active",
  },
  {
    waveid: "019",
    description: "New Wave",
    priority: "Medium",
    maxorderlimit: 4,
    picktype: "Single shipment",
    shippingtype: "2/Pkg Per Order",
    createdat: "10/07/2023",
    status: "Inactive",
  },
  {
    waveid: "020",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/06/2023",
    status: "Active",
  },
  {
    waveid: "021",
    description: "New Wave",
    priority: "High",
    maxorderlimit: 6,
    picktype: "Multi shipment",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/05/2023",
    status: "Inactive",
  },
  {
    waveid: "022",
    description: "New Wave",
    priority: "Medium",
    maxorderlimit: 3,
    picktype: "Single shipment",
    shippingtype: "2/Pkg Per Order",
    createdat: "10/04/2023",
    status: "Active",
  },
  {
    waveid: "023",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/03/2023",
    status: "Inactive",
  },
  {
    waveid: "012",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "011",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "010",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "009",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "008",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "007",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
  {
    waveid: "006",
    description: "New Wave",
    priority: "Low",
    maxorderlimit: 2,
    picktype: "Multi shipment with sort",
    shippingtype: "1/Pkg Per Order",
    createdat: "10/18/2023",
    status: "Active",
  },
];

export const priorityData = [
  { id: 2, label: "High", value: "high" },
  { id: 3, label: "Medium", value: "medium" },
  { id: 4, label: "Low", value: "low" },
];

export const packagingData = [
  { id: 1, label: "UPS Box", value: "ups_box" },
  { id: 2, label: "Cardboard boxes", value: "cardboard_boxes" },
  { id: 3, label: "Corrugated boxes", value: "corrugated_boxes" },
  { id: 4, label: "Glass Containers", value: "glass_containers" },
  { id: 5, label: "Shrink Wrap", value: "shrink_wrap" },
];
export const addLineItem = [
  {
    Line: "1",
    ItemCode: "Ip125478",
    imgSrc: "phone1.jpg",
    ItemDescription: "GARNIER SKIN NATURALS ...",
    UOM: "EA",
    ExpectedQty: "0",
    BackorderQty: "2",
    ReceivedQuantity: "25",
    quantityOnHand: "4",
  },
];
export const allocationData = [
  { id: 1, label: "DTL Bin Location", value: "dtl_bin_location" },
  { id: 2, label: "DTL FIFO/LIFO", value: "dtl_fifo_lifo" },
  { id: 3, label: "DTL Lot #", value: "dtl_lot" },
  { id: 4, label: "DTL Quantity Allocated", value: "dtl_quantity_allocated" },

];

// data for create wave
export const customerCodeList = [
  { value: "1", label: "3RCOMI" },
  { value: "2", label: "4CATVI" },
  { value: "3", label: "4THWAV" },
];
export const billToCodeList = [
  { value: "1", label: "CS-478" },
  { value: "2", label: "CS-996" },
  { value: "3", label: "CS-335" },
];
export const shipToCodeList = [
  { value: "1", label: "BS-478" },
  { value: "2", label: "BS-996" },
  { value: "3", label: "BS-335" },
];
export const countryList = [
  { value: "1", label: "USA" },
  { value: "2", label: "UK" },
  { value: "3", label: "UAE" },
  { value: "4", label: "SA" },
];
export const carrierLevelOptionsList = [
  { value: "1", label: "UPS" },
  { value: "2", label: "Express" },
  { value: "3", label: "Priority" },
];
export const serviceLevelOptionsList = [
  { value: "1", label: "UPS-Ground" },
  { value: "2", label: "Express" },
  { value: "3", label: "Priority" },
];
export const addOrderEntryLineItem = [
  {
    Line: "1",
    ItemCode: "Ip125478",
    imgSrc: "phone1.jpg",
    ItemDescription: "GARNIER SKIN NATURALS ...",
    ShippingUOM: "EA",
    quantityOrder: "4",
  },
  {
    Line: "2",
    ItemCode: "Mac125478",
    imgSrc: "phone1.jpg",
    ItemDescription: "Mac Book 1",
    ShippingUOM: "EA",
    quantityOrder: "2",
  },
  {
    Line: "3",
    ItemCode: "Mac082024",
    imgSrc: "phone1.jpg",
    ItemDescription: "Mac Pro Book",
    ShippingUOM: "EA",
    quantityOrder: "45",
  },
];

export const failedOrdersData = [
  {
    title: "Order.csv",
    dateUploaded: "07/10/2023",
    createdBy: "John",
    errors: "20",
  },
  {
    title: "Order1.csv",
    dateUploaded: "07/10/2023",
    createdBy: "Robert",
    errors: "5",
  },
  {
    title: "Order12.csv",
    dateUploaded: "07/10/2023",
    createdBy: "William",
    errors: "2",
  },
  {
    title: "Order123.csv",
    dateUploaded: "07/10/2023",
    createdBy: "Smith",
    errors: "23",
  },
  {
    title: "Order21.csv",
    dateUploaded: "07/10/2023",
    createdBy: "Josef",
    errors: "10",
  },
];
export const orderEnrtyEditData = [
  {
    billToCode: "B12345",
    shipToCode: "S67890",
    contactName: "John Doe",
    companyName: "Acme Corporation",
    address1: "123 Main St",
    address2: "Suite 400",
    city: "Springfield",
    state: "IL",
    postalCode: "62704",
    country: "USA",
    phoneNumber: "555-123-4567",
    orderDate: "2025-01-22T00:00:00.000Z",
    shipDate: "2025-01-25T00:00:00.000Z",
    carrirLevel: "Priority",
    refernceField1: "Ref001",
    refernceField2: "Ref002",
    notesField: "Handle with care.",
    specialInstructionsField: "Deliver between 9 AM and 5 PM.",
  },
];

// data for shipments
export const shipmentsOverviewPendingData = [
  {
    shipment_number: "SH-100011",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Jacob",
    ship_by_date: "02/15/2020",
    request_qty: 25,
    pick_qty: "-",
    remaining_qty: "-",
    status: "Past Due",
  },
  {
    shipment_number: "SH-100011",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Michael",
    ship_by_date: "02/16/2020",
    request_qty: 205,
    pick_qty: "-",
    remaining_qty: "-",
    status: "Past Due",
  },
  {
    shipment_number: "SH-100012",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Kavien",
    ship_by_date: "02/15/2020",
    request_qty: 75,
    pick_qty: "-",
    remaining_qty: "-",
    status: "Past Due",
  },
  {
    shipment_number: "SH-100013",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Jackson",
    ship_by_date: "02/14/2020",
    request_qty: 140,
    pick_qty: "-",
    remaining_qty: "-",
    status: "Past Due",
  },
  {
    shipment_number: "SH-100014",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Owen",
    ship_by_date: "03/17/2020",
    request_qty: 159,
    pick_qty: "-",
    remaining_qty: "-",
    status: "Due Now",
  },
  {
    shipment_number: "SH-100015",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Samuel",
    ship_by_date: "03/15/2020",
    request_qty: 168,
    pick_qty: "-",
    remaining_qty: "-",
    status: "Due Now",
  },
  {
    shipment_number: "SH-100018",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Matthew",
    ship_by_date: "03/14/2020",
    request_qty: 88,
    pick_qty: "-",
    remaining_qty: "-",
    status: "Due Now",
  },
  {
    shipment_number: "SH-100019",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Kavien",
    ship_by_date: "03/13/2020",
    request_qty: 95,
    pick_qty: "-",
    remaining_qty: "-",
    status: "Due Now",
  },
  {
    shipment_number: "SH-100020",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Joseph",
    ship_by_date: "03/12/2020",
    request_qty: 35,
    pick_qty: "-",
    remaining_qty: "-",
    status: "Due Now",
  },
  {
    shipment_number: "SH-100022",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "David",
    ship_by_date: "03/11/2020",
    request_qty: 15,
    pick_qty: "-",
    remaining_qty: "-",
    status: "Due Now",
  },
  {
    shipment_number: "SH-100032",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Anthony",
    ship_by_date: "03/10/2020",
    request_qty: 25,
    pick_qty: "-",
    remaining_qty: "-",
    status: "Due Now",
  },
];

export const shipmentsOverviewPickingData = [
  {
    shipment_number: "SH-100011",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Jacob",
    ship_by_date: "03/17/2020",
    request_qty: 25,
    pick_qty: 18,
    remaining_qty: "-",
    status: "In Picking",
  },
  {
    shipment_number: "SH-100011",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Michael",
    ship_by_date: "03/17/2020",
    request_qty: 205,
    pick_qty: 150,
    remaining_qty: "-",
    status: "In Picking",
  },
  {
    shipment_number: "SH-100012",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Kavien",
    ship_by_date: "03/17/2020",
    request_qty: 75,
    pick_qty: 60,
    remaining_qty: 15,
    status: "Pick Missing",
  },
  {
    shipment_number: "SH-100013",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Jackson",
    ship_by_date: "03/17/2020",
    request_qty: 140,
    pick_qty: 130,
    remaining_qty: 10,
    status: "Pick Missing",
  },
  {
    shipment_number: "SH-100014",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Owen",
    ship_by_date: "03/17/2020",
    request_qty: 159,
    pick_qty: 129,
    remaining_qty: "-",
    status: "In Picking",
  },
  {
    shipment_number: "SH-100015",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Samuel",
    ship_by_date: "03/17/2020",
    request_qty: 168,
    pick_qty: 100,
    remaining_qty: "-",
    status: "In Picking",
  },
  {
    shipment_number: "SH-100018",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Matthew",
    ship_by_date: "03/17/2020",
    request_qty: 88,
    pick_qty: 22,
    remaining_qty: "-",
    status: "In Picking",
  },
  {
    shipment_number: "SH-100019",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Kavien",
    ship_by_date: "03/17/2020",
    request_qty: 95,
    pick_qty: 90,
    remaining_qty: "-",
    status: "In Picking",
  },
  {
    shipment_number: "SH-100020",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Joseph",
    ship_by_date: "03/17/2020",
    request_qty: 35,
    pick_qty: 32,
    remaining_qty: "-",
    status: "In Picking",
  },
  {
    shipment_number: "SH-100022",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "David",
    ship_by_date: "03/17/2020",
    request_qty: 15,
    pick_qty: 9,
    remaining_qty: "-",
    status: "In Picking",
  },
  {
    shipment_number: "SH-100032",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Anthony",
    ship_by_date: "03/17/2020",
    request_qty: 25,
    pick_qty: 20,
    remaining_qty: "-",
    status: "In Picking",
  },
];

export const shipmentsOverviewPackingData = [
  {
    shipment_number: "SH-100011",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Jacob",
    ship_by_date: "03/17/2020",
    request_qty: 25,
    pick_qty: 25,
    remaining_qty: "-",
    status: "In Packing",
  },
  {
    shipment_number: "SH-100011",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Michael",
    ship_by_date: "03/17/2020",
    request_qty: 205,
    pick_qty: 205,
    remaining_qty: "-",
    status: "In Packing",
  },
  {
    shipment_number: "SH-100012",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Kavien",
    ship_by_date: "03/17/2020",
    request_qty: 75,
    pick_qty: 70,
    remaining_qty: "-",
    status: "In Packing",
  },
  {
    shipment_number: "SH-100013",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Jackson",
    ship_by_date: "03/17/2020",
    request_qty: 140,
    pick_qty: 130,
    remaining_qty: "-",
    status: "In Packing",
  },
  {
    shipment_number: "SH-100014",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Owen",
    ship_by_date: "03/17/2020",
    request_qty: 159,
    pick_qty: 159,
    remaining_qty: "-",
    status: "In Packing",
  },
  {
    shipment_number: "SH-100015",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Samuel",
    ship_by_date: "03/17/2020",
    request_qty: 168,
    pick_qty: 168,
    remaining_qty: "-",
    status: "In Packing",
  },
  {
    shipment_number: "SH-100018",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Matthew",
    ship_by_date: "03/17/2020",
    request_qty: 88,
    pick_qty: 88,
    remaining_qty: "-",
    status: "In Packing",
  },
  {
    shipment_number: "SH-100019",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Kavien",
    ship_by_date: "03/17/2020",
    request_qty: 95,
    pick_qty: 95,
    remaining_qty: "-",
    status: "In Packing",
  },
  {
    shipment_number: "SH-100020",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Joseph",
    ship_by_date: "03/17/2020",
    request_qty: 35,
    pick_qty: 35,
    remaining_qty: "-",
    status: "In Packing",
  },
  {
    shipment_number: "SH-100022",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "David",
    ship_by_date: "03/17/2020",
    request_qty: 15,
    pick_qty: 15,
    remaining_qty: "-",
    status: "In Packing",
  },
  {
    shipment_number: "SH-100032",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Anthony",
    ship_by_date: "03/17/2020",
    request_qty: 25,
    pick_qty: 25,
    remaining_qty: "-",
    status: "In Packing",
  },
];

export const shipmentsOverviewShippingData = [
  {
    shipment_number: "SH-100011",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Jacob",
    ship_by_date: "03/17/2020",
    request_qty: 25,
    pick_qty: 20,
    remaining_qty: "-",
    status: "Ready to Ship",
  },
  {
    shipment_number: "SH-100011",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Michael",
    ship_by_date: "03/17/2020",
    request_qty: 205,
    pick_qty: 188,
    remaining_qty: "-",
    status: "Ready to Ship",
  },
  {
    shipment_number: "SH-100012",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Kavien",
    ship_by_date: "03/17/2020",
    request_qty: 75,
    pick_qty: 52,
    remaining_qty: "-",
    status: "Ready to Ship",
  },
  {
    shipment_number: "SH-100013",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Jackson",
    ship_by_date: "03/17/2020",
    request_qty: 140,
    pick_qty: 140,
    remaining_qty: "-",
    status: "Ready to Ship",
  },
  {
    shipment_number: "SH-100014",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Owen",
    ship_by_date: "03/17/2020",
    request_qty: 159,
    pick_qty: 117,
    remaining_qty: "-",
    status: "Ready to Ship",
  },
  {
    shipment_number: "SH-100015",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Samuel",
    ship_by_date: "03/17/2020",
    request_qty: 168,
    pick_qty: 140,
    remaining_qty: "-",
    status: "Ready to Ship",
  },
  {
    shipment_number: "SH-100018",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Matthew",
    ship_by_date: "03/17/2020",
    request_qty: 88,
    pick_qty: 88,
    remaining_qty: "-",
    status: "Ready to Ship",
  },
  {
    shipment_number: "SH-100019",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Kavien",
    ship_by_date: "03/17/2020",
    request_qty: 95,
    pick_qty: 60,
    remaining_qty: "-",
    status: "Ready to Ship",
  },
  {
    shipment_number: "SH-100020",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Joseph",
    ship_by_date: "03/17/2020",
    request_qty: 35,
    pick_qty: 22,
    remaining_qty: "-",
    status: "Ready to Ship",
  },
  {
    shipment_number: "SH-100022",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "David",
    ship_by_date: "03/17/2020",
    request_qty: 15,
    pick_qty: 12,
    remaining_qty: "-",
    status: "Ready to Ship",
  },
  {
    shipment_number: "SH-100032",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Anthony",
    ship_by_date: "03/17/2020",
    request_qty: 25,
    pick_qty: 25,
    remaining_qty: "-",
    status: "Ready to Ship",
  },
];
export const shipmentsOverviewShippedData = [
  {
    shipment_number: "SH-100011",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Jacob",
    ship_by_date: "03/17/2020",
    request_qty: 25,
    pick_qty: 25,
    remaining_qty: "-",
    status: "Shipped",
  },
  {
    shipment_number: "SH-100011",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Michael",
    ship_by_date: "03/17/2020",
    request_qty: 205,
    pick_qty: 205,
    remaining_qty: "-",
    status: "Shipped",
  },
  {
    shipment_number: "SH-100012",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Kavien",
    ship_by_date: "03/17/2020",
    request_qty: 75,
    pick_qty: 75,
    remaining_qty: "-",
    status: "Shipped",
  },
  {
    shipment_number: "SH-100013",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Jackson",
    ship_by_date: "03/17/2020",
    request_qty: 140,
    pick_qty: 140,
    remaining_qty: "-",
    status: "Shipped",
  },
  {
    shipment_number: "SH-100014",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Owen",
    ship_by_date: "03/17/2020",
    request_qty: 159,
    pick_qty: 159,
    remaining_qty: "-",
    status: "Shipped",
  },
  {
    shipment_number: "SH-100015",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Samuel",
    ship_by_date: "03/17/2020",
    request_qty: 168,
    pick_qty: 168,
    remaining_qty: "-",
    status: "Shipped",
  },
  {
    shipment_number: "SH-100018",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Matthew",
    ship_by_date: "03/17/2020",
    request_qty: 88,
    pick_qty: 88,
    remaining_qty: "-",
    status: "Shipped",
  },
  {
    shipment_number: "SH-100019",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Kavien",
    ship_by_date: "03/17/2020",
    request_qty: 95,
    pick_qty: 95,
    remaining_qty: "-",
    status: "Shipped",
  },
  {
    shipment_number: "SH-100020",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Joseph",
    ship_by_date: "03/17/2020",
    request_qty: 35,
    pick_qty: 35,
    remaining_qty: "-",
    status: "Shipped",
  },
  {
    shipment_number: "SH-100022",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "David",
    ship_by_date: "03/17/2020",
    request_qty: 15,
    pick_qty: 15,
    remaining_qty: "-",
    status: "Shipped",
  },
  {
    shipment_number: "SH-100032",
    no_of_lines: 3,
    bill_to: "Michael",
    ship_to: "Anthony",
    ship_by_date: "03/17/2020",
    request_qty: 25,
    pick_qty: 25,
    remaining_qty: "-",
    status: "Shipped",
  },
];

// outbound shipment detail data
export const shipmentsDetailData = [
  {
    Line: "1",
    ItemCode: "Ip1254789",
    ItemName: "Iphone x",
    UOM: "EA",
    RequestQty: "5",
    ShippedQty: "-",
    RemainingQty: "-",
  },
  {
    Line: "2",
    ItemCode: "Ip1254789",
    ItemName: "Iphone x",
    UOM: "EA",
    RequestQty: "5",
    ShippedQty: "-",
    RemainingQty: "-",
  },
  {
    Line: "3",
    ItemCode: "Ipod145874",
    ItemName: "I Pods",
    UOM: "EA",
    RequestQty: "10",
    ShippedQty: "-",
    RemainingQty: "-",
  },
  {
    Line: "4",
    ItemCode: "Mac25478",
    ItemName: "Mac Book",
    UOM: "EA",
    RequestQty: "10",
    ShippedQty: "-",
    RemainingQty: "-",
  },
];
//Waves Overview Attach Order Data
export const wavesOverviewAttachOrderData = [
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    noOfLines: 4,
    noOfShipments: 0,
    noOfWarehouses: 0,
    qtyOrder: 10,
    qtyBackorder: 0,
    qtyShipment: 0,
    action: "Attach Order",
  },
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    noOfLines: 4,
    noOfShipments: 0,
    noOfWarehouses: 0,
    qtyOrder: 10,
    qtyBackorder: 0,
    qtyShipment: 0,
    action: "Attach Order",
  },
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    noOfLines: 4,
    noOfShipments: 0,
    noOfWarehouses: 0,
    qtyOrder: 10,
    qtyBackorder: 0,
    qtyShipment: 0,
    action: "Attach Order",
  },
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    noOfLines: 4,
    noOfShipments: 0,
    noOfWarehouses: 0,
    qtyOrder: 10,
    qtyBackorder: 0,
    qtyShipment: 0,
    action: "Attach Order",
  },
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    noOfLines: 4,
    noOfShipments: 0,
    noOfWarehouses: 0,
    qtyOrder: 10,
    qtyBackorder: 0,
    qtyShipment: 0,
    action: "Attach Order",
  },
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    noOfLines: 4,
    noOfShipments: 0,
    noOfWarehouses: 0,
    qtyOrder: 10,
    qtyBackorder: 0,
    qtyShipment: 0,
    action: "Attach Order",
  },
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    noOfLines: 4,
    noOfShipments: 0,
    noOfWarehouses: 0,
    qtyOrder: 10,
    qtyBackorder: 0,
    qtyShipment: 0,
    action: "Attach Order",
  },
  {
    orderNumber: "OR-1482",
    shipToName: "James",
    shipByDate: "01-07-2023",
    noOfLines: 4,
    noOfShipments: 0,
    noOfWarehouses: 0,
    qtyOrder: 10,
    qtyBackorder: 0,
    qtyShipment: 0,
    action: "Attach Order",
  },
];

// Outbound pick list

export const readyToPickData = [
  {
    pickTicketNumber: "PT-874601",
    noOfLines: 4,
    totalQty: 44,
    pickedQty: "_",
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "-",
    status: "Ready to Pick",
  },
  {
    pickTicketNumber: "PT-874602",
    noOfLines: 3,
    totalQty: 55,
    pickedQty: "_",
    pickArea: "Zone 1",
    pickMethod: "Multi Shipment with sort",
    assignedTo: "-",
    status: "Ready to Pick",
  },
  {
    pickTicketNumber: "PT-874603",
    noOfLines: 6,
    totalQty: 125,
    pickedQty: "_",
    pickArea: "Zone 1",
    pickMethod: "Multi Shipment without sort",
    assignedTo: "-",
    status: "Ready to Pick",
  },
  {
    pickTicketNumber: "PT-874604",
    noOfLines: 8,
    totalQty: 236,
    pickedQty: "_",
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "-",
    status: "Ready to Pick",
  },
  {
    pickTicketNumber: "PT-874605",
    noOfLines: 4,
    totalQty: 487,
    pickedQty: "_",
    pickArea: "Zone 5",
    pickMethod: "Single Order",
    assignedTo: "-",
    status: "Ready to Pick",
  },
  {
    pickTicketNumber: "PT-874606",
    noOfLines: 2,
    totalQty: 785,
    pickedQty: "_",
    pickArea: "Zone 5",
    pickMethod: "Multi Shipment with sort",
    assignedTo: "-",
    status: "Ready to Pick",
  },
];
export const pickInProgressData = [
  {
    pickTicketNumber: "PT-874601",
    noOfLines: 2,
    totalQty: 44,
    pickedQty: 10,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Sebastian",
    status: "Pick Exited",
  },
  {
    pickTicketNumber: "PT-874602",
    noOfLines: 3,
    totalQty: 55,
    pickedQty: 12,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Sebastian",
    status: "Pick Exited",
  },
  {
    pickTicketNumber: "PT-874603",
    noOfLines: 6,
    totalQty: 125,
    pickedQty: 15,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Sebastian",
    status: "Pick In Progress",
  },
  {
    pickTicketNumber: "PT-874604",
    noOfLines: 8,
    totalQty: 236,
    pickedQty: 100,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Samuel",
    status: "Pick In Progress",
  },
  {
    pickTicketNumber: "PT-874605",
    noOfLines: 4,
    totalQty: 487,
    pickedQty: 350,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Samuel",
    status: "Pick In Progress",
  },
  {
    pickTicketNumber: "PT-874606",
    noOfLines: 2,
    totalQty: 785,
    pickedQty: 700,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Samuel",
    status: "Pick In Progress",
  },
  {
    pickTicketNumber: "PT-874607",
    noOfLines: 2,
    totalQty: 698,
    pickedQty: 600,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Santiago",
    status: "Pick In Progress",
  },
  {
    pickTicketNumber: "PT-874608",
    noOfLines: 3,
    totalQty: 125,
    pickedQty: 0,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Santiago",
    status: "Pick In Progress",
  },
  {
    pickTicketNumber: "PT-874609",
    noOfLines: 2,
    totalQty: 136,
    pickedQty: 136,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Santiago",
    status: "Pick In Progress",
  },
  {
    pickTicketNumber: "PT-874610",
    noOfLines: 3,
    totalQty: 147,
    pickedQty: 147,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Silas",
    status: "Pick In Progress",
  },
  {
    pickTicketNumber: "PT-874611",
    noOfLines: 2,
    totalQty: 114,
    pickedQty: 114,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Silas",
    status: "Pick In Progress",
  },
];
export const pickWithIssues = [
  {
    pickTicketNumber: "PT-874601",
    noOfLines: 2,
    totalQty: 44,
    pickedQty: 10,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Missing",
  },
  {
    pickTicketNumber: "PT-874602",
    noOfLines: 4,
    totalQty: 55,
    pickedQty: 12,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Missing",
  },
  {
    pickTicketNumber: "PT-874603",
    noOfLines: 3,
    totalQty: 125,
    pickedQty: 15,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Missing",
  },
  {
    pickTicketNumber: "PT-874604",
    noOfLines: 3,
    totalQty: 236,
    pickedQty: 100,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Damaged",
  },
  {
    pickTicketNumber: "PT-874605",
    noOfLines: 6,
    totalQty: 487,
    pickedQty: 350,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Damaged",
  },
  {
    pickTicketNumber: "PT-874606",
    noOfLines: 8,
    totalQty: 785,
    pickedQty: 700,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Missing",
  },
  {
    pickTicketNumber: "PT-874607",
    noOfLines: 4,
    totalQty: 698,
    pickedQty: 600,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Damaged",
  },
  {
    pickTicketNumber: "PT-874608",
    noOfLines: 2,
    totalQty: 125,
    pickedQty: 0,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Missing",
  },
  {
    pickTicketNumber: "PT-874609",
    noOfLines: 2,
    totalQty: 136,
    pickedQty: 136,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Missing",
  },
  {
    pickTicketNumber: "PT-874610",
    noOfLines: 3,
    totalQty: 147,
    pickedQty: 147,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Missing",
  },
  {
    pickTicketNumber: "PT-874611",
    noOfLines: 2,
    totalQty: 114,
    pickedQty: 114,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Missing",
  },
];
export const pickComplete = [
  {
    pickTicketNumber: "PT-874601",
    noOfLines: 2,
    totalQty: 44,
    pickedQty: 44,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Complete",
  },
  {
    pickTicketNumber: "PT-874602",
    noOfLines: 4,
    totalQty: 55,
    pickedQty: 55,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Complete",
  },
  {
    pickTicketNumber: "PT-874603",
    noOfLines: 3,
    totalQty: 125,
    pickedQty: 125,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Complete",
  },
  {
    pickTicketNumber: "PT-874604",
    noOfLines: 3,
    totalQty: 236,
    pickedQty: 236,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Complete",
  },
  {
    pickTicketNumber: "PT-874605",
    noOfLines: 6,
    totalQty: 487,
    pickedQty: 487,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Complete",
  },
  {
    pickTicketNumber: "PT-874606",
    noOfLines: 8,
    totalQty: 785,
    pickedQty: 785,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Complete",
  },
  {
    pickTicketNumber: "PT-874607",
    noOfLines: 4,
    totalQty: 698,
    pickedQty: 698,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Complete",
  },
  {
    pickTicketNumber: "PT-874608",
    noOfLines: 2,
    totalQty: 125,
    pickedQty: 125,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Complete",
  },
  {
    pickTicketNumber: "PT-874609",
    noOfLines: 2,
    totalQty: 136,
    pickedQty: 136,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Complete",
  },
  {
    pickTicketNumber: "PT-874610",
    noOfLines: 3,
    totalQty: 147,
    pickedQty: 147,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Complete",
  },
  {
    pickTicketNumber: "PT-874611",
    noOfLines: 2,
    totalQty: 114,
    pickedQty: 114,
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "Steven Smith",
    status: "Pick Complete",
  },
];
export const pickListData = [
  {
    pickTicketNumber: "PT-874601",
    noOfLines: 4,
    totalQty: 44,
    pickedQty: "_",
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "-",
    status: "Ready to Pick",
  },
  {
    pickTicketNumber: "PT-874602",
    noOfLines: 3,
    totalQty: 55,
    pickedQty: "_",
    pickArea: "Zone 1",
    pickMethod: "Multi Shipment with sort",
    assignedTo: "-",
    status: "Ready to Pick",
  },
  {
    pickTicketNumber: "PT-874603",
    noOfLines: 6,
    totalQty: 125,
    pickedQty: "_",
    pickArea: "Zone 1",
    pickMethod: "Multi Shipment without sort",
    assignedTo: "-",
    status: "Ready to Pick",
  },
  {
    pickTicketNumber: "PT-874604",
    noOfLines: 8,
    totalQty: 236,
    pickedQty: "_",
    pickArea: "Zone 1",
    pickMethod: "Single Order",
    assignedTo: "-",
    status: "Ready to Pick",
  },
  {
    pickTicketNumber: "PT-874605",
    noOfLines: 4,
    totalQty: 487,
    pickedQty: "_",
    pickArea: "Zone 5",
    pickMethod: "Single Order",
    assignedTo: "-",
    status: "Ready to Pick",
  },
  {
    pickTicketNumber: "PT-874606",
    noOfLines: 2,
    totalQty: 785,
    pickedQty: "_",
    pickArea: "Zone 5",
    pickMethod: "Multi Shipment with sort",
    assignedTo: "-",
    status: "Ready to Pick",
  },
];

//Outbound Pack List
export const readytoPackdata = [
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Pack",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Pack",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Pack",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Pack",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Pack",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Pack",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Pack",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Pack",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Pack",
  },
];

export const packInProgressData = [
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 20,
    packArea: "Pack Station",
    status: "Pack In Progress",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 16,
    packArea: "Pack Station",
    status: "Pack In Progress",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 22,
    packArea: "Pack Station",
    status: "Pack In Progress",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 12,
    packArea: "Pack Station",
    status: "Pack In Progress",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 22,
    packArea: "Pack Station",
    status: "Pack In Progress",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 14,
    packArea: "Pack Station",
    status: "Pack In Progress",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 18,
    packArea: "Pack Station",
    status: "Pack In Progress",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 23,
    packArea: "Pack Station",
    status: "Pack In Progress",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 19,
    packArea: "Pack Station",
    status: "Pack In Progress",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 14,
    packArea: "Pack Station",
    status: "Pack In Progress",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 17,
    packArea: "Pack Station",
    status: "Pack In Progress",
  },
];
export const packCompleteData = [
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 25,
    packArea: "Pack Station",
    status: "Pack Complete",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 25,
    packArea: "Pack Station",
    status: "Pack Complete",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 25,
    packArea: "Pack Station",
    status: "Pack Complete",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 25,
    packArea: "Pack Station",
    status: "Pack Complete",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 25,
    packArea: "Pack Station",
    status: "Pack Complete",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 25,
    packArea: "Pack Station",
    status: "Pack Complete",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 25,
    packArea: "Pack Station",
    status: "Pack Complete",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 25,
    packArea: "Pack Station",
    status: "Pack Complete",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 25,
    packArea: "Pack Station",
    status: "Pack Complete",
  },
  {
    shipment: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 25,
    packArea: "Pack Station",
    status: "Pack Complete",
  },
];
export const readyToPickDetailData = [
  {
    shipmentLine: 1,
    location: "B1-P01",
    itemCode: "ip1154",
    description: "iPhone",
    uom: "EA",
    shipmentNumber: "SH-100010",
    qtyToPick: 10,
    pickedQty: "-",
    recounted: true,
  },
  {
    shipmentLine: 2,
    location: "A1-P01",
    itemCode: "ipd1145",
    description: "iPad",
    uom: "EA",
    shipmentNumber: "SH-100010",
    qtyToPick: 8,
    pickedQty: "-",
    recounted: false,
  },
  {
    shipmentLine: 3,
    location: "A1-P03",
    itemCode: "ipd1145",
    description: "iPad",
    uom: "EA",
    shipmentNumber: "SH-100010",
    qtyToPick: 12,
    pickedQty: "-",
    recounted: false,
  },
  {
    shipmentLine: 4,
    location: "B1-P02",
    itemCode: "ap15478",
    description: "AirPods",
    uom: "EA",
    shipmentNumber: "SH-100010",
    qtyToPick: 14,
    pickedQty: "-",
    recounted: false,
  },
];
export const readyToPackDetailData = [
  {
    shipmentLine: 1,
    pickTicket: "Ip125478",
    noOfPicks: "Iphone x",
    totalQty: "EA",
    pickedQty: 25,
    pickMethod: "Single Order",
    assignedTo: "Sebastian",
    detail: "Link",
  },
  {
    shipmentLine: 2,
    pickTicket: "Mac125478",
    noOfPicks: "Mac Book",
    totalQty: "EA",
    pickedQty: 10,
    pickMethod: "Multi Shipment with sort",
    assignedTo: "Sebastian",
    detail: "Link",
  },
  {
    shipmentLine: 3,
    pickTicket: "Ip125478",
    noOfPicks: "Iphone x",
    totalQty: "EA",
    pickedQty: 25,
    pickMethod: "Single Order",
    assignedTo: "Sebastian",
    detail: "Link",
  },
  {
    shipmentLine: 4,
    pickTicket: "Mac125478",
    noOfPicks: "Mac Book",
    totalQty: "EA",
    pickedQty: 10,
    pickMethod: "Multi Shipment with sort",
    assignedTo: "Sebastian",
    detail: "Link",
  },
  {
    shipmentLine: 4,
    pickTicket: "Mac125478",
    noOfPicks: "Mac Book",
    totalQty: "EA",
    pickedQty: 10,
    pickMethod: "Multi Shipment with sort",
    assignedTo: "Sebastian",
    detail: "Link",
  },
  {
    shipmentLine: 4,
    pickTicket: "Mac125478",
    noOfPicks: "Mac Book",
    totalQty: "EA",
    pickedQty: 10,
    pickMethod: "Multi Shipment with sort",
    assignedTo: "Sebastian",
    detail: "Link",
  },
  {
    shipmentLine: 4,
    pickTicket: "Mac125478",
    noOfPicks: "Mac Book",
    totalQty: "EA",
    pickedQty: 10,
    pickMethod: "Multi Shipment with sort",
    assignedTo: "Sebastian",
    detail: "Link",
  },
  {
    shipmentLine: 4,
    pickTicket: "Mac125478",
    noOfPicks: "Mac Book",
    totalQty: "EA",
    pickedQty: 10,
    pickMethod: "Multi Shipment with sort",
    assignedTo: "Sebastian",
    detail: "Link",
  },
];
export const readyToShipData = [
  {
    shipmentNumber: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Ship",
  },
  {
    shipmentNumber: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Ship",
  },
  {
    shipmentNumber: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Ship",
  },
  {
    shipmentNumber: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Ship",
  },
  {
    shipmentNumber: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Ship",
  },
  {
    shipmentNumber: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Ship",
  },
  {
    shipmentNumber: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Ship",
  },
  {
    shipmentNumber: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Ship",
  },
  {
    shipmentNumber: "SH-8574123",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 25,
    pickedQty: 25,
    packingQty: 0,
    packArea: "Pack Station",
    status: "Ready To Ship",
  },
];

export const shipInProgress = [
  {
    shipmentNumber: "SH-8574124",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 30,
    pickedQty: 30,
    packingQty: 10,
    packArea: "Pack Station",
    status: "Ship In Progress",
  },
  {
    shipmentNumber: "SH-8574125",
    shipTo: "Liora",
    packMethod: "Standard Pack",
    shipmentQty: 40,
    pickedQty: 40,
    packingQty: 25,
    packArea: "Zone A",
    status: "Ship In Progress",
  },
  {
    shipmentNumber: "SH-8574126",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 20,
    pickedQty: 20,
    packingQty: 5,
    packArea: "Zone B",
    status: "Ship In Progress",
  },
  {
    shipmentNumber: "SH-8574127",
    shipTo: "OmniCorp",
    packMethod: "Standard Pack",
    shipmentQty: 50,
    pickedQty: 50,
    packingQty: 30,
    packArea: "Pack Station",
    status: "Ship In Progress",
  },
  {
    shipmentNumber: "SH-8574128",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 35,
    pickedQty: 35,
    packingQty: 18,
    packArea: "Zone C",
    status: "Ship In Progress",
  },
];

export const shippedData = [
  {
    shipmentNumber: "SH-8574129",
    shipTo: "Kavien",
    packMethod: "Pack With Audit",
    shipmentQty: 30,
    pickedQty: 30,
    packingQty: 30,
    packArea: "Pack Station",
    status: "Shipped",
  },
  {
    shipmentNumber: "SH-8574130",
    shipTo: "Liora",
    packMethod: "Standard Pack",
    shipmentQty: 45,
    pickedQty: 45,
    packingQty: 45,
    packArea: "Zone A",
    status: "Shipped",
  },
  {
    shipmentNumber: "SH-8574131",
    shipTo: "OmniCorp",
    packMethod: "Pack With Audit",
    shipmentQty: 50,
    pickedQty: 50,
    packingQty: 50,
    packArea: "Zone B",
    status: "Shipped",
  },
  {
    shipmentNumber: "SH-8574132",
    shipTo: "Solara Inc.",
    packMethod: "Standard Pack",
    shipmentQty: 60,
    pickedQty: 60,
    packingQty: 60,
    packArea: "Pack Station",
    status: "Shipped",
  },
  {
    shipmentNumber: "SH-8574133",
    shipTo: "NovaTech",
    packMethod: "Pack With Audit",
    shipmentQty: 38,
    pickedQty: 38,
    packingQty: 38,
    packArea: "Zone C",
    status: "Shipped",
  },
  {
    shipmentNumber: "SH-8574134",
    shipTo: "NovaTech",
    packMethod: "Pack With Audit",
    shipmentQty: 38,
    pickedQty: 38,
    packingQty: 38,
    packArea: "Zone C",
    status: "Shipped",
  },
  {
    shipmentNumber: "SH-8574135",
    shipTo: "NovaTech",
    packMethod: "Pack With Audit",
    shipmentQty: 38,
    pickedQty: 38,
    packingQty: 38,
    packArea: "Zone C",
    status: "Shipped",
  },
  {
    shipmentNumber: "SH-8574136",
    shipTo: "NovaTech",
    packMethod: "Pack With Audit",
    shipmentQty: 38,
    pickedQty: 38,
    packingQty: 38,
    packArea: "Zone C",
    status: "Shipped",
  },
  {
    shipmentNumber: "SH-8574137",
    shipTo: "NovaTech",
    packMethod: "Pack With Audit",
    shipmentQty: 38,
    pickedQty: 38,
    packingQty: 38,
    packArea: "Zone C",
    status: "Shipped",
  },
];
export const addOrderData = [
  {
    itemCode: "IP-29839",
    itemDescription: "IPhone XS",
    shippingUom: "EA",
    qtyOrder: "",
  },
  {
    itemCode: "IP-23539",
    itemDescription: "IPhone 14",
    shippingUom: "EA",
    qtyOrder: "",
  },
  {
    itemCode: "IP-02198",
    itemDescription: "IPhone 6s",
    shippingUom: "EA",
    qtyOrder: "",
  },
  {
    itemCode: "IP-12908",
    itemDescription: "IPhone X",
    shippingUom: "EA",
    qtyOrder: "",
  },
  {
    itemCode: "IP-38123",
    itemDescription: "IPhone XS Max",
    shippingUom: "EA",
    qtyOrder: "",
  },
];

export const allocationPlanData = [
  {
    allocation_plan_id: "OR-100345",
    description: "John",
    client: "Client 100",
    warehouse: "Warehouse #1",
  },
  {
    allocation_plan_id: "OR-100345",
    description: "John",
    client: "Client 100",
    warehouse: "Warehouse #1",
  },
  {
    allocation_plan_id: "OR-100345",
    description: "John",
    client: "Client 100",
    warehouse: "Warehouse #1",
  },
  {
    allocation_plan_id: "OR-100345",
    description: "John",
    client: "Client 100",
    warehouse: "Warehouse #1",
  },
  {
    allocation_plan_id: "OR-100345",
    description: "John",
    client: "Client 100",
    warehouse: "Warehouse #1",
  },
  {
    allocation_plan_id: "OR-100345",
    description: "John",
    client: "Client 100",
    warehouse: "Warehouse #1",
  },
  {
    allocation_plan_id: "OR-100345",
    description: "John",
    client: "Client 100",
    warehouse: "Warehouse #1",
  },
  {
    allocation_plan_id: "OR-100345",
    description: "John",
    client: "Client 100",
    warehouse: "Warehouse #1",
  },
  {
    allocation_plan_id: "OR-100345",
    description: "John",
    client: "Client 100",
    warehouse: "Warehouse #1",
  },
  {
    allocation_plan_id: "OR-100345",
    description: "John",
    client: "Client 100",
    warehouse: "Warehouse #1",
  },
];

export const allocationIdData = [
  { id: 1, label: "001", value: "001 " },
  { id: 2, label: "002", value: "002" },
  { id: 3, label: "003", value: "003" },
  { id: 4, label: "004", value: "004" },
  { id: 5, label: "005", value: "005" },
];
export const allocationDescriptionData = [
  { id: 1, label: "001-Warehouse 1- Client 1", value: "001" },
  { id: 2, label: "002-Warehouse 2- Client 2", value: "002" },
  { id: 3, label: "003-Warehouse 3- Client 3", value: "003" },
  { id: 4, label: "004-Warehouse 4- Client 4", value: "004" },
];

export const InvStatusDropdownList = [
  { label: "Finish Goods", value: "Finish Goods" },
  { label: "QC Holds", value: "QC Holds" },
  { label: "Damaged", value: "Damaged" },
  { label: "In Transit", value: "In Transit" },
  { label: "On Hold", value: "On Hold" },
];

export const allocationDirectionData = [
  { id: 1, label: "ASC", value: "asc" },
  { id: 2, label: "DESC", value: "desc" },
];

export const allocationOperatorData = [
  { id: 1, label: "=", value: "=" },
  { id: 2, label: "!=", value: "!=" },
  { id: 3, label: ">", value: ">" },
  { id: 4, label: "<", value: "<" },
]

export const allocationlogicalOperatorData = [
  { id: 1, label: "AND", value: "and" },
  { id: 2, label: "OR", value: "or" },
  { id: 3, label: "NOT", value: "not" },

]

export const allocationValueData = [
  { id: 1, label: "Client ID", value: "clientid " },
  { id: 2, label: "UOM Code", value: "uomcode" },
]
export const allocationConditionData = 
[
  { "column": "Client ID","operator": "Equal to", "value": 12, },
  { "column": "UOM Code","operator": "Not equal to", "value": 29, },
  { "column": "Client ID","operator": "Equal to", "value": 12, },
  { "column": "UOM Code","operator": "Not equal to", "value": 29, },
    { "column": "Client ID","operator": "Equal to", "value": 12, },
  { "column": "UOM Code","operator": "Not equal to", "value": 29, },
  { "column": "Client ID","operator": "Equal to", "value": 12, },
  { "column": "UOM Code","operator": "Not equal to", "value": 29, },

];
export const allocationOrderByData = 
[
  { "column": "FIFO Date","direction": "ASC" },
  { "column": "Ship By Date","direction": "DESC" },
  { "column": "Ship By Date","direction": "ASC" },
  { "column": "FIFO Date","direction": "DESC" },
  { "column": "Ship By Date","direction": "ASC" },
  { "column": "FIFO Date","direction": "DESC" },
  { "column": "Ship By Date","direction": "ASC" },
];